<div class="app-container">
    <div class="app-loading" *ngIf="loading">
        <img class="loading-t-logo loading-t-logo-IE11" src="./assets/images/iosT.png">
        <div class="loading-spinner loading-spinner-IE11"></div>
    </div>
    <router-outlet>
    </router-outlet>
</div>